module.exports = window["__MFE_SHARED__"]["react/jsx-runtime"];